import type { CountMenuBadgesResp } from '@/types';
import { gatewayRequest, type RequestOptions } from '@/utils/http';

/**
 * 菜单待办角标（API-10-200）。
 *
 * 一次取回「当前帐号看得见、且登记过数据源」的那些页面各有多少条待办；服务端已经按
 * 会话的 `reachableRoutes` 过滤过，前端不用再判权限，直接按菜单树相加。
 */
export const countMenuBadges = (options?: RequestOptions) =>
  gatewayRequest<CountMenuBadgesResp>('/admin/iam/menu/countBadges', {
    method: 'POST',
    ...options,
  });

/** 业务处理完成后立即通知布局重新读取正式角标。 */
export function refreshMenuBadges() {
  window.dispatchEvent(new Event('muou:menu-badges-refresh'));
}
